/**
 * "Test this camera" on the camera page (ENG-2457): opens the camera check
 * narrowed to this camera, where a full test runs with `camera_ids=[id]`.
 * View Only users get "Camera check" and see results only.
 */
import React from "react";
import { TsButton } from "../../Troubleshooting/TroubleshootingUi";
import { SiteConnectivityDialog } from "./SiteConnectivitySection";

export const CameraTestButton = ({
  siteId,
  cameraId,
  cameraName,
  canRun,
}: {
  siteId: number;
  cameraId: number;
  cameraName?: string | null;
  canRun: boolean;
}) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <TsButton
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        data-testid="camera-test-button"
      >
        {canRun ? "Test this camera" : "Camera check"}
      </TsButton>
      <SiteConnectivityDialog
        open={open}
        onClose={() => setOpen(false)}
        siteId={siteId}
        siteName={cameraName}
        canRun={canRun}
        cameraIds={[cameraId]}
        title="Camera check"
      />
    </>
  );
};
